/* this file is transformed by vux-loader */
/* eslint-disable */
import TpLoadingBar from './TpLoadingBar';
import Vue from 'vue';
var _config = {
  percent: 0,
  status: 'success',
  isShow: false,
  failedcolor: 'error'
};
var time;
var Instance = new Vue({
  data: _config,
  render: function render(h) {
    return h(TpLoadingBar, {
      props: _config
    });
  }
});
var component = Instance.$mount();
document.body.appendChild(component.$el);

function update(data) {
  for (var key in data) {
    if (component.$data.hasOwnProperty(key)) {
      component.$data[key] = data[key];
    }
  }
}

function hide() {
  var data = _config;
  data.isShow = false;
  update(data);
}

var destroy = function destroy() {
  document.body.removeChild(document.getElementsByClassName('shy__loading-bar')[0]);
};

var start = function start() {
  if (time) clearInterval(time);
  var data = _config;
  data.percent = 0;
  data.status = 'success';
  data.isShow = true;
  time = setInterval(function () {
    data.percent += 10;
    if (data.percent >= 90) clearInterval(time);
    update(data);
  }, 500);
};

var finish = function finish() {
  if (time) clearInterval(time);
  update({
    percent: 100,
    status: 'success'
  });
  setTimeout(function () {
    hide();
  }, 500);
};

var error = function error() {
  if (time) clearInterval(time);
  update({
    percent: 100,
    status: 'error',
    failedColor: _config.failedColor
  });
  setTimeout(function () {
    hide();
  }, 500);
};

var config = function config(_config2) {
  if (_config2.color) {
    _config.color = _config2.color;
  }

  if (_config2.failedColor) {
    _config.failedColor = _config2.failedColor;
  }
};

var tpLoadingTar = {
  start: start,
  error: error,
  finish: finish,
  destroy: destroy,
  config: config
};
export default tpLoadingTar;